export default "__VITE_ASSET__DPixEQJB__"